import { IGamePlay } from '@/interface/gamePlay';

export const confirmGamePlay = (sceneId: string, data: any) => {
  const gamePlay: IGamePlay = {
    sceneId,
    switchGroup: {
      guideReply: data?.guideReply?.isOpen,
      botGroupChat: data?.botGroupChat?.isOpen,
      narration: data?.narration?.isOpen,
      numSys: data?.numSys?.isOpen,
      countDown: data?.countDown?.isOpen,
      sendImage: data?.sendImage?.isOpen,
    },
    numSys: {
      isOpen: data?.numSys?.isOpen,
      rules: data?.numSys?.rules || [],
    },
    countDown: data?.countDown?.val || 0,
    selectedBotIds: data?.botGroupChat?.selectedBotIds || [],
    botChatToBot: data?.botGroupChat?.botChatToBot || false,
    botChatToBotRound: data?.botGroupChat?.botChatToBotRound || 1,
  };
  return gamePlay;
};

export const postGamePlay = (data: IGamePlay) => {
  const chat = data.switchGroup.botGroupChat ? {
    selectedBotIds: data.selectedBotIds,
    botChatToBot: data.botChatToBot,
    botChatToBotRound: data.botChatToBotRound,
  } : {
    selectedBotIds: [],
    botChatToBot: false,
    botChatToBotRound: 0,
  };

  const postData = {
    guideReply: { isOpen: data.switchGroup.guideReply },
    botGroupChat: {
      isOpen: data.switchGroup.botGroupChat,
      ...chat,
    },
    narration: { isOpen: data.switchGroup.narration },
    numSys: {
      isOpen: data?.switchGroup?.numSys,
      rules: data?.numSys?.rules || [],
    },
    countDown: { isOpen: data.switchGroup.countDown, val: data.countDown },
    sendImage: { isOpen: data.switchGroup.sendImage },
  };
  return postData;
};
